import * as moment from 'moment';
import {NgbDate, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {DateEncoding} from "./DateEncoding";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

export class Utils {


  public static lowerCase(toLower):string{
    let res = <string>toLower;
    return res.toLowerCase();
  }

  public static decimalToHexString(number): string{
    if (this.isNullOrUndefined(number)){
      return '0x000000';
    }
    if (number < 0){
      number = 0xFFFFFFFF + number + 1;
    }
    return number.toString(16).toUpperCase();
  }


  public static decimalToHexColor(number): string{
    if (this.isNullOrUndefined(number)){
      return '0x000000';
    }
    if (number < 0){
      number = 0xFFFFFFFF + number + 1;
    }
    let res = number.toString(16).toUpperCase();
    if (res.length===2){
      res = '00' + res;
    }
    if (res.length===4){
      res = '00' + res;
    }
    return res;
  }


  public static toDay(refDate: Date): string {
    const m = moment(refDate).day();
    switch (m) {
      case 0: return 'SUNDAY';
      case 1: return 'MONDAY';
      case 2: return 'TUESDAY';
      case 3: return 'WEDNESDAY';
      case 4: return 'THURSDAY';
      case 5: return 'FRIDAY';
      case 6: return 'SATURDAY';
    }
  }

  /**
   * 13:31 will become 14:00
   * 14:05 will become 14:30
   * 13:30 will become 13:30
   * 14:00 will become 14:00
   */
  public static roundingDateToNext30(refDate: Date):Date{
    const ref = moment(refDate);
    if (ref.minute()>30){
      ref.add(1,'hour');
      ref.minute(0);
    }
    if (ref.minute()>0 && ref.minute()<30){
      ref.minute(30);
    }
    return ref.toDate();
  }

  /**
   * 13:31 will become 13:00
   * 14:05 will become 13:30
   */
  public static roundingDateToPrevious30(refDate: Date):Date{
    const ref = moment(refDate);
    if (ref.minute()>30){
      ref.minute(30);
    }
    if (ref.minute()>0 && ref.minute()<30){
      ref.minute(0);
    }
    return ref.toDate();
  }


  public static binaryToLong(binary: string): number {
    let tmp = 0;
    let pow = 0;
    for (let idx = binary.length - 1 ; idx >= 0; idx-- ) {
      if (binary.charAt(idx) === '1') {
        tmp += Math.pow(2, pow);
      }
      pow++;
    }
    return tmp;
  }

  public static longToBinary(val: number): string {
    return val.toString(2);
  }
//
//   public static int getMinutesDelta(Date date1, Date date2) {
//   if (date1 == null || date2 == null) {
//   return 0;
// }
// return (int)((date2.getTime() - date1.getTime()) / 60000);
// }

  public static retrieveDayBeforeOrEquals(dayOfWeek:number,date: Date):moment.Moment{

    let tmp = moment(date);

    while (tmp.day()!=dayOfWeek){
      tmp = tmp.add(-1,'day');
    }
    return tmp.startOf('day');

  }


  public static diffDateInMinutes(start: Date, end: Date): number {
    if (start && end ) {
       // return moment(end).diff(moment(start), 'minutes');
      return moment(end).second(0).diff(moment(start).second(0), 'minutes');
    }
    return 0;
  }

  public static diffDateInDays(start: Date, end: Date): number {
    if (start && end ) {
      return moment(end).diff(moment(start), 'days');
    }
    return 0;
  }


  static createKeyJobUnitEmployee(jobId: string, unitId: string, employeeId: string) {
    let res = '';
    if ( jobId ) {
      res += jobId;
    }
    if ( res.length > 0 ) {
      res += '.';
    }
    if ( unitId ) {
      res += unitId;
    }
    if ( res.length > 0 ) {
      res += '.';
    }
    if ( employeeId ) {
      res += employeeId;
    }
    return res;
  }


  static createKeyJobUnitEmployeeAndYearWeek(jobId: string, unitId: string, employeeId: string, yearWeek: string) {
    return Utils.createKeyJobUnitEmployee(jobId,unitId,employeeId) + '.' + yearWeek;
  }

  static createKeyEmployeeAndYearWeek(employeeId: string, yearWeek: string) {
    return employeeId + '.' + yearWeek;
  }


  static createKeyJobUnitAndYearWeek(jobId: string, unitId: string, yearWeek: string) {
    return Utils.createKeyJobUnit(jobId,unitId) + '.' + yearWeek;
  }



  static createKeyJobUnit(jobId: string, unitId: string) {
    let res = '';
    if ( jobId ) {
      res += jobId;
    }
    if ( res.length > 0 ) {
      res += '.';
    }
    if ( unitId ) {
      res += unitId;
    }
    return res;
  }


  static createKeyIntervalJobWithDates(startHour: Date, endHour: Date, jobId: string): string {
    // const de = new DateEncoding();
    // const ms = moment(startHour);
    // const me = moment(endHour);
    // const res = de.encodeWithOvernightCheck({h:ms.hour(),m:ms.minute()},{h:me.hour(),m:me.minute()});
    //
    // return this.createKeyIntervalJob(res.interval,res.intervalOverNight,jobId);
    return this.createKeyIntervalJob(startHour,endHour,jobId);
    /*
    // return de.encode(startHour, endHour) + '.' + jobId;
    let tmp = res.interval + '.';
    if (res.intervalOverNight>0){
      tmp += res.intervalOverNight + '.';
    }
    tmp += jobId;
    return tmp;
    */
  }
  /*
  static createKeyIntervalJob(interval: number,intervalOverNight: number, jobId: string): string{
    let tmp = interval + '.';
    if (intervalOverNight>0){
      tmp += intervalOverNight + '.';
    }
    tmp += jobId;
    return tmp;

  }
  */

  static createKeyIntervalJob(startHour: Date,endHour: Date, jobId: string): string{
    let tmp =  moment(startHour).format('LT') + '.' + moment(endHour).format('LT') + '.';
    tmp += jobId;
    return tmp;

  }


  static createKeyIntervalJobUnit(refDate: Date, startHour: Date,endHour: Date, jobId: string, unitId: string): string{
    let tmp =  moment(refDate).format('L') + '.' + moment(startHour).format('LT') + '.' + moment(endHour).format('LT') + '.';
    tmp += jobId;
    tmp += '.' + unitId;
    return tmp;

  }



  static sameDay(d1: Date, d2: Date):boolean{
    return this.sameDayMoment(moment(d1),moment(d2));
  }

  static sameDayMoment(d1: moment.Moment, d2: moment.Moment):boolean{
     if (d1.date()===d2.date() && d1.month()===d2.month() && d1.year()===d2.year()){
        return true;
     }
     return false;
  }


  static sameMonthMoment(d1: moment.Moment, d2: moment.Moment):boolean{
    if (d1.month()===d2.month() && d1.year()===d2.year()){
      return true;
    }
    return false;
  }

  static sameYearMoment(d1: moment.Moment, d2: moment.Moment):boolean{
    if (d1.year()===d2.year()){
      return true;
    }
    return false;
  }






  static sameDayHourMin(d1: Date, d2: Date):boolean{
    return this.sameDayHourMinMoment(moment(d1),moment(d2));
  }

  static sameDayHourMinMoment(d1: moment.Moment, d2: moment.Moment):boolean{
    if (d1.date()===d2.date() && d1.month()===d2.month() && d1.year()===d2.year() && d1.hour()===d2.hour() && d1.minute()===d2.minute()){
      return true;
    }
    return false;
  }


  static sameHourMin(d1: Date, d2: Date):boolean{
    return this.sameHourMinMoment(moment(d1),moment(d2));
  }
  static sameHourMinMoment(d1: moment.Moment, d2: moment.Moment):boolean{
    if (d1.hour()===d2.hour() && d1.minute()===d2.minute()){
      return true;
    }
    return false;
  }
  static sameOrAfterHour(d1: moment.Moment, hour:number){
    if (d1.hour() >= hour){
      return true;
    }else{
      return false;
    }
  }
  static sameOrBeforeHour(d1: moment.Moment, hour:number){
    if (d1.hour() <= hour){
      return true;
    }else{
      return false;
    }
  }

  static isHourIncluded(hour:number, startHour: Date,endHour: Date){
      let res = false;
      if (startHour){
        if (Utils.sameOrBeforeHour(moment(startHour),hour)){
          if (endHour){
            if (Utils.sameOrAfterHour(moment(endHour),hour)){
               res = true;
            }
          }else{
            res = true;
          }
        }
      }else{
        if (endHour){
          if (Utils.sameOrAfterHour(moment(endHour),hour)){
            res = true;
          }
        }else{
          res = true;
        }
      }
      if (res===false){
        if (startHour && endHour){
          //Overnight
          if (Utils.isOvernightWithDate(startHour,endHour)){
            const hourStart = moment(startHour).hour();
            const hourEnd = moment(endHour).hour();
            if (hour>=hourStart && hourEnd < hour){
              res = true;
            }else if (hour <= hourEnd && hour>=0){
                res = true;
            }
            console.log('TEsting overnight: ' + startHour + " - " + endHour + " checking: " + hour+ " res is " + res);

            /*
            const today = moment();
            const tomorrow = today.add(1,'day');
            const startDt = Utils.mixDateAndHourMinute(today.toDate(),startHour);
            const toCheckToday = today.hour(hour).minute(0).toDate();
            const toCheckTomorrow = tomorrow.hour(hour).minute(0).toDate();
            const endDt = Utils.mixDateAndHourMinute(tomorrow.toDate(),endHour);


            if (Utils.isAfterRefDate(toCheckToday,startDt)){
              if (Utils.isBeforeRefDate(toCheckToday,endDt)){
                   res = true;
              }
            }
            console.log('TEsting overnight: ' + startDt + " - " + endDt + " toCheckToday: " + toCheckToday + " res is " + res);
            if (res === false){
              if (Utils.isAfterRefDate(toCheckTomorrow,startDt)){
                if (Utils.isBeforeRefDate(toCheckTomorrow,endDt)){
                  res = true;
                }
              }
            }
            console.log('TEsting overnight: ' + startDt + " - " + endDt + " toCheckToday: " + toCheckTomorrow + " res is " + res);
             */

          }
        }
      }
      return res;
  }

  static isAnyHourIncluded(hours:number[], startHour: Date,endHour: Date):boolean{
    for (const hour of hours){
      if (this.isHourIncluded(hour,startHour,endHour)){
        return true;
      }
    }
    return false;
  }




  static createKeyDateAndEmployeeId(refDate: Date, employeeId: string): string{
    const dt = moment(refDate).format('YYYYMMDD');
    const key = dt + '.' + employeeId;
    return key;
  }

  static createKeyForDate(refDate: Date): string {
    return moment(refDate).format('YYYYMMDD');
  }


  static createKeyForYearWeek(refDate: Date): string {
    return moment(refDate).format('ggggww');
    // return moment(refDate).format('YYYYww');
    // return moment(refDate).format('YYYYWW');
  }


  static retrieveYearWeekFromKey(key:string): moment.Moment {
    // return moment(key,'YYYYww');
    return moment(key,'ggggww');
  }


  static getDistinctKeyYearWeek(start:Date, end:Date):string[]{
    if (moment(start).isAfter(moment(end),'day')){
      return [];
    }
    let tmp = moment(start);
    const stop = moment(end);
    const res = new Map<string,string>();
    while (tmp.isSameOrBefore(stop,'day')){

      const key = Utils.createKeyForYearWeek(tmp.toDate());
      if (!res.has(key)){
        res.set(key,key);
      }
      tmp = tmp.add(1,'day');
    }
    const resString = Array.from(res.keys());
    return resString.sort();
  }



  static isToday(refDate: Date) : boolean{
    return this.sameDay(refDate,moment().toDate());
  }

  static isAfterToday(refDate: Date) : boolean{
      if (refDate) {
        const m = moment(refDate);
        // console.log('refDate: ' + this.refDate);
        if (m.isAfter(moment().add(-1,'day'), 'day')) {
          return true;
        }else {
          // console.log(' AFTER refDate: ' + this.refDate);
        }
      }else {
        // console.log('refDate is null');
      }
      return false;
  }


  static isBeforeToday(refDate: Date) : boolean{
    if (refDate) {
      const m = moment(refDate);
      // console.log('refDate: ' + this.refDate);
      if (m.isBefore(moment(), 'day')) {
        return true;
      }else {
        // console.log(' AFTER refDate: ' + this.refDate);
      }
    }else {
      // console.log('refDate is null');
    }
    return false;
  }


  static mixDateAndHourMinute(dt: Date, hour: Date): Date{
    const hr = moment(hour);
    return moment(dt).startOf('day').hour(hr.hour()).minute(hr.minute()).toDate();
  }

  static isAfterRefDate(toCheck:Date, refDate: Date) : boolean{
    if (refDate) {
      const ref = moment(refDate);
      if (toCheck){
        const chk = moment(toCheck);
        if (chk.isAfter(ref,'minute')){
          // console.log(chk.format('LLL') + ' is after ' + ref.format('LLL'));
          return true;
        }else{
          // console.log(chk.format('LLL') + ' is NOT after ' + ref.format('LLL'));
        }
      }
    }
    return false;
  }

  static isBeforeRefDate(toCheck:Date, refDate: Date) : boolean{
    if (refDate) {
      const ref = moment(refDate);
      if (toCheck){
        const chk = moment(toCheck);
        if (chk.isBefore(ref,'minute')){
          return true;
        }
      }
    }
    return false;
  }

  static isBeforeMyBirthday(birthday: Date, refDate :Date) :boolean{
    if (birthday){
      if (refDate){
        const ref = moment(refDate);
        const bday = moment(birthday);
        bday.year(ref.year());
        const res = ref.isSameOrBefore(bday,'day');
       // console.log('isBeforeMyBirthday: ' + ref.toDate() + ' bday: ' + bday.toDate() + " : " + res);
        return res;
      }
    }
    return false;
  }

  static isAfterMyBirthday(birthday: Date, refDate :Date) :boolean{
    if (birthday){
      if (refDate){
        const ref = moment(refDate);
        const bday = moment(birthday);
        bday.year(ref.year());
        return ref.isSameOrAfter(bday,'day');
      }
    }
    return false;
  }


  static currentBirthday(birthday: Date, refDate :Date) :Date | undefined{
    if (birthday){
      if (refDate){
        const ref = moment(refDate);
        const bday = moment(birthday);
        bday.year(ref.year());
        return bday.toDate();
      }
    }
  }



  static isValidEmail(email: string):boolean {
    if (!this.isNullOrUndefined(email)){
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    return false;
  }

  static copyToClipboard(data: string){
      let selBox = document.createElement('textarea');

      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.width = '0';
      selBox.style.opacity = '0';
      selBox.value = data;

      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      selBox.focus();

      document.execCommand('copy');

      document.body.removeChild(selBox);
  }



  static isMidnightHourMin(end: {h: number, m: number}): boolean {
    if ((end.h === 0) && (end.m === 0)) {
      return true;
    }
    return false;
  }

  static isMidnight( date:Date): boolean{
    if (this.isNullOrUndefined(date)) {
      return false;
    }
    const mmnt: moment.Moment =  moment(date);
    return this.isMidnightHourMin({h:mmnt.hour(),m:mmnt.minute()});
  }


  static stringToBoolean(s: string):boolean{
    if (this.isNullOrUndefined(s)){
      return false;
    }
    if ('Y' === s.toUpperCase()){
      return true;
    }
    if ('YES' === s.toUpperCase()){
      return true;
    }
    if ('TRUE' === s.toUpperCase()){
      return true;
    }
    return false;
  }


  static booleanToString(b: boolean):string{
    if (this.isNullOrUndefined(b)){
      return 'N';
    }
    if (b){
      return 'Y';
    }
    return 'N';
  }


  /**
   18:30-03:00 is overnight
   22:00-24:30 is overnight
   22:00-24:00 is not
   14:00-15:00 is considered as 1 hour shift not a 25 hours shift.

   18:30-00:00 is NOT overnight
   22:00-00:01 is overnight
   */
  static isOvernight(start: {h: number, m: number}, end: {h: number, m: number}): boolean {
    if (start.h > end.h) {
      if (end.h===0 && end.m===0){
        return false;
      }
      return true;
    }
    // We are supporting the 24 format to simplify the reading...
    // 19:30 - 24:30 is legal for us and means 7:30 pm to 0:30 am
    if ((end.h === 24) && (end.m > 0)) {
      return true;
    }
    return false;
  }

  static isOvernightWithDate(start: Date, end:Date):boolean{
    const ms = moment(start);
    const me = moment(end);
    return this.isOvernight({h:ms.hour(),m:ms.minute()},{h:me.hour(),m:me.minute()});
  }

  public static toNgbDateStruct(date: Date): NgbDateStruct{
    const tmp = moment(date);
    return {day: tmp.date(), month: tmp.month()+1, year: tmp.year()}
  }

  public static toNgbDate(date: Date): NgbDate{
    return NgbDate.from(this.toNgbDateStruct(date));
  }


  public static toDate(date: NgbDateStruct): Date{
    return this.toDateWithStartOfDay(date,true);
  }

  public static toDateWithStartOfDay(date: NgbDateStruct,startOfDay:boolean): Date{
    let tmp = moment();
    tmp.year(date.year).month(date.month-1).date(date.day);

    // tmp = tmp.date(date.day);
    // tmp = tmp.month(date.month - 1);
    // tmp = tmp.year(date.year);
    if (startOfDay===true){
      tmp = tmp.startOf('day');
    }
    return tmp.toDate();
  }


  static isNullOrUndefined(value: any): boolean{
    if (value === undefined || value === null){
      return true;
    }
    return false;
  }


  static isDefined(value: any): boolean{
    if (this.isNullOrUndefined(value)){
      return false;
    }
    return true;
  }

  static isEmpty(value: string): boolean{
    if (!this.isNullOrUndefined(value)){
      if (value.trim().length>0){
        return false;
      }
    }
    return true;
  }


  static multiLineNote(note:string, domSanitizer: DomSanitizer):SafeHtml{
    if (note){
      return domSanitizer.bypassSecurityTrustHtml(note.split('\\n').join('<br>'));
    }
    return domSanitizer.bypassSecurityTrustHtml("");
  }


  static sortAny(s1: any, s2:any){
    if (s1){
      if (s2){
        return 0;
      }else{
        return 1;
      }
    }else{
      return -1;
    }
  }


  static sortStrings(s1: string, s2:string){
    let res = this.sortAny(s1,s2);
    if (res===0){
      return s1.toLowerCase().localeCompare(s2.toLowerCase());
    }
  }

  static testTimeZones(){
    /** TEST ALBERTA */
//    console.log('ALBERTA untils ' + moment.tz.zone("America/Edmonton").untils);

    const dateInAlbertaSummer2025 = moment.tz("2025-06-15", "America/Edmonton");
    console.log('ALBERTA- June 2025: DST ? ' + dateInAlbertaSummer2025.isDST()); // true (Summer)

    const dateInAlbertaWinter2025 = moment.tz("2025-12-15", "America/Edmonton");
    console.log('ALBERTA- December 2025: DST ? ' + dateInAlbertaWinter2025.isDST()); // true (Summer)


    const dateInAlberta = moment.tz("2026-06-15", "America/Edmonton");
    console.log('ALBERTA- June 2026: DST ? ' + dateInAlberta.isDST()); // true (Summer)

    const dateInAlbertaWinter = moment.tz("2026-11-15", "America/Edmonton");
    console.log('ALBERTA- December 2026: DST ? ' + dateInAlbertaWinter.isDST()); // true (Summer)

    const dateInBCSummer2025 = moment.tz("2025-06-15", "America/Vancouver");
    console.log('BC- June 2025: DST ? ' + dateInBCSummer2025.isDST()); // true (Summer)

    const dateInBCWinter2025 = moment.tz("2025-12-15", "America/Vancouver");
    console.log('BC- December 2025: DST ? ' + dateInBCWinter2025.isDST()); // true (Summer)


    const dateInBC = moment.tz("2026-06-15", "America/Vancouver");
    console.log('BC- June 2026: DST ? ' + dateInBC.isDST()); // true (Summer)

    const dateInBCWinter = moment.tz("2026-11-15", "America/Vancouver");
    console.log('BC- December 2026: DST ? ' + dateInBCWinter.isDST()); // true (Summer)
  }


}
